import { decodeJWT } from '@codezo/auth';

/**
 * Whether an access token belongs to a vetter-LINK session rather than an
 * account.
 *
 * Both are vetter logins sharing one refresh cookie, so the role can't tell
 * them apart. The backend stamps `vetterLinkId` on tokens minted by
 * `vetterJobLogin`; that claim is what binds the session to its one job, and
 * what makes the portal's operations refuse it.
 */
export function isLinkSessionToken(token: string | null | undefined): boolean {
	if (!token) return false;
	return typeof decodeJWT(token)?.vetterLinkId === 'string';
}
